import React from "react"
import blogImg from "../img/about-1.jpg"
import howWeWorkImgOne from "../img/impact-1.png"
import howWeWorkImgTwo from "../img/knowledge-1.png"
import howWeWorkImgThree from "../img/guidance-1.png"
import howWeWorkImgFour from "../img/community-1.png"
import NavigationBar from "../components/Navbar"
import Footer from "../components/footer"
import NewsletterStrip from "../components/newsletterStrip"
import Team from "../components/Team"
import { Helmet } from "react-helmet"

export default function AboutUs() {
  return (
    <div>
      <div className="-mb-12 bg-white">
        <Helmet>
          <meta charSet="utf-8" />
          <title>About Us</title>
          <meta name="description" content="About Us Page" />
        </Helmet>
        <NavigationBar />
        <div className="max-w-screen-xl px-4 mx-auto lg:mt-28 sm:px-6 lg:px-8">
          <div className="mt-10 lg:grid lg:grid-cols-12 lg:gap-8">
            <div className="md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left">
              <div className="">
                <h2 className="mb-6 -mt-10 text-3xl font-bold leading-10 tracking-tight text-gray-900 md:text-4xl lg:text-left md:text-left sm:leading-none">
                  A team of passionate professionals
                </h2>
              </div>
              <p className="mt-3 text-base text-gray-500 lg:text-left md:text-left sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">
                We are a team of experts from Top tech companies, Super 30, IIT
                and world-class universities who enjoy programming,
                problem-solving, and collaboration. We are on a life-long
                mission to promote value-based education in computer science.
              </p>
              <div className="mt-5 sm:max-w-lg sm:mx-auto sm:text-center lg:text-left lg:mx-0"></div>
            </div>
            <div className="relative mt-4 sm:max-w-lg sm:mx-auto lg:-mt-14 lg:max-w-none lg:mx-0 lg:col-span-6 lg:flex lg:items-center">
              <div className="relative w-full mx-auto rounded-lg lg:max-w-md">
                <button className="relative block w-full overflow-hidden rounded-lg focus:outline-none">
                  <img
                    className="w-full rounded-xl"
                    src={blogImg}
                    alt="Woman making a sale"
                  />
                  <div className="absolute inset-0 flex items-center justify-center w-full h-full"></div>
                </button>
              </div>
            </div>
          </div>

          <div className="">
            <h3 className="text-3xl font-bold leading-10 tracking-tight text-gray-900 md:text-4xl lg:text-left md:text-left sm:leading-10">
              How we work
            </h3>
          </div>

          <div className="-mb-16 bg-white lg:mb-10">
            <div className="max-w-screen-xl px-0 pt-6 pb-12 mx-auto sm:px-6 lg:px-8 lg:py-12">
              <div className="space-y-12">
                <ul className="space-y-12 lg:grid lg:grid-cols-2 lg:items-start lg:col-gap-8 lg:row-gap-12 lg:space-y-0">
                  <li className="">
                    <div className="mt-6 space-y-4 sm:grid sm:grid-cols-3 sm:gap-6 sm:space-y-0 lg:gap-8">
                      <div className="pb-2/3 sm:pt-2/3">
                        <img
                          className="object-contain w-1/2 rounded-lg h-1/2 lg:w-full lg:h-full justify-self-center md:w-1/2 md:h-1/2"
                          src={howWeWorkImgOne}
                          alt=""
                        />
                      </div>
                      <div className="sm:col-span-2 lg:mr-10">
                        <div className="space-y-4">
                          <div className="space-y-1 text-lg font-medium leading-6">
                            <p className="font-bold lg:text-left md:text-left">
                              Impact Focused Vision
                            </p>
                          </div>
                          <div className="text-lg leading-7">
                            <p className="text-gray-500 lg:text-left md:text-left">
                              We believe computer science is a 21st-century
                              domain that can transform millions of lives and
                              provide sustainable solutions to several real-life
                              problems.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>

                  <li>
                    <div className="mt-6 space-y-4 sm:grid sm:grid-cols-3 sm:gap-6 sm:space-y-0 lg:gap-8">
                      <div className="pb-2/3 sm:pt-2/3">
                        <img
                          className="object-contain w-1/2 rounded-lg h-1/2 lg:w-full lg:h-full justify-self-center md:w-1/2 md:h-1/2"
                          src={howWeWorkImgTwo}
                          alt=""
                        />
                      </div>
                      <div className="sm:col-span-2 lg:mr-10">
                        <div className="space-y-4">
                          <div className="space-y-1 text-lg font-medium leading-6">
                            <p className="font-bold lg:text-left md:text-left">
                              Simplification of Knowledge
                            </p>
                          </div>
                          <div className="text-lg leading-7">
                            <p className="text-gray-500 lg:text-left md:text-left">
                              We follow the design thinking process to create
                              content with in-depth explanations. We are on a
                              mission to organize computer science knowledge.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>

                  <li>
                    <div className="mt-6 space-y-4 sm:grid sm:grid-cols-3 sm:gap-6 sm:space-y-0 lg:gap-8">
                      <div className="pb-2/3 sm:pt-2/3">
                        <img
                          className="object-contain w-1/2 rounded-lg h-1/2 lg:w-full lg:h-full justify-self-center md:w-1/2 md:h-1/2"
                          src={howWeWorkImgThree}
                          alt=""
                        />
                      </div>
                      <div className="sm:col-span-2 lg:mr-10">
                        <div className="space-y-4">
                          <div className="space-y-1 text-lg font-medium leading-6">
                            <p className="font-bold lg:text-left md:text-left">
                              Success Oriented Guidance
                            </p>
                          </div>
                          <div className="text-lg leading-7">
                            <p className="text-gray-500 lg:text-left md:text-left">
                              We help programmers to define goals, plan a guided
                              learning path, and achieve a dream career with
                              continuous growth. We believe in a learner-centric
                              approach.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>

                  <li>
                    <div className="-mt-6 space-y-4 lg:mt-6 md:mt-6 sm:grid sm:grid-cols-3 sm:gap-6 sm:space-y-0 lg:gap-8">
                      <div className="-mb-6 pb-2/3 sm:pt-2/3 lg:mb-0 md:mb-0">
                        <img
                          className="object-contain w-1/2 rounded-lg h-1/2 lg:w-full lg:h-full justify-self-center md:w-1/2 md:h-1/2"
                          src={howWeWorkImgFour}
                          alt=""
                        />
                      </div>
                      <div className="sm:col-span-2 lg:mr-10">
                        <div className="space-y-4">
                          <div className="space-y-1 text-lg font-medium leading-6">
                            <p className="font-bold lg:text-left md:text-left">
                              World-Class Community
                            </p>
                          </div>
                          <div className="text-lg leading-7">
                            <p className="text-gray-500 lg:text-left md:text-left">
                              We are on a mission to build a network of
                              programmers who share ideas, collaborate to solve
                              problems and help each other find career
                              opportunities.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Team />
      <NewsletterStrip />
      <Footer />
    </div>
  )
}
